import React from 'react';
import { showTip, appDefIds } from '@wix/business-manager-api';

import { getStores } from '../../client/stores';
import { get } from '../../client/utils/data';
import {
  default as CatalogLinkContent,
  Footer as CatalogLinkFooter,
  SubTitle as CatalogLinkSubTitle,
} from './client/components/flow-modals/catalog-link';
import Requirements from './client/components/flow-modals/requirements';

export const key = 'facebook-catalog';

export const integration = (experiments) => ({
  key,
  basic: {
    title: 'facebook-catalog.widget.title',
    description: 'facebook-catalog.widget.description',
  },
  requiredPermissions: [],
  detailed: (api, config) =>
    new Promise((resolve) => {
      let csvExportLink;
      let fetchCsvExportLink;
      const biData = {
        integrationType: key,
      };
      const { biLogger } = getStores();
      const getDataFeedAction = {
        type: 'edit',
        label: 'facebook-catalog.details-page.cta.title.MI1.5',
        icon: <span />,
        handler: () => {
          const openCatalogLinkModal = (link) => {
            biData.modalType = 'facebook catalog link';
            api.openFlowModal({
              title: 'facebook-catalog.modal.title',
              subTitleNode: <CatalogLinkSubTitle />,
              contentNode: <CatalogLinkContent link={link} />,
              buttons: {
                primary: {
                  text: 'modal.button.close',
                  onClick: (modalAPI) => {
                    modalAPI.close();
                    biLogger.integrationModalCtaClick({
                      ...biData,
                      ctaType: 'close',
                    });
                  },
                },
                x: {
                  onClick: () =>
                    biLogger.integrationModalCloseViaCloseBar(biData),
                },
              },
              footnoteNode: <CatalogLinkFooter />,
              onOpened: () => biLogger.integrationModalView(biData),
              onClosed: () => {
                showTip({
                  sourceApplication: appDefIds.marketingIntegration,
                });
                biLogger.integrationModalClosed(biData);
              },
            });
          };

          const openRequirementsModal = () => {
            biData.modalType = 'facebook catalog requirements';
            const msid = api.getMetaSiteId();
            api.openFlowModal({
              title: 'facebook-catalog.requirements.title',
              contentNode: (
                <Requirements
                  requirements={[
                    {
                      titleKey: 'facebook-catalog.requirements.store.title',
                      linkLabel: 'facebook-catalog.requirements.store.button',
                      link: `https://www.wix.com/editor/${msid}?openpanel=market:appDefId:1380b703-ce81-ff05-f115-39571d94dfcd`,
                    },
                    {
                      titleKey: 'facebook-catalog.requirements.publish.title',
                      linkLabel: 'facebook-catalog.requirements.publish.button',
                      link: `https://www.wix.com/editor/${msid}`,
                    },
                  ]}
                />
              ),
              buttons: {
                primary: {
                  text: 'facebook-catalog.requirements.primary-button',
                  onClick: (modalAPI) => {
                    biLogger.integrationModalCtaClick({
                      ...biData,
                      ctaType: 'refresh',
                    });
                    modalAPI.setLoading(true);
                    fetchCsvExportLink().then(({ link }) => {
                      modalAPI.setLoading(false);
                      if (link) {
                        csvExportLink = link;
                        modalAPI.close();
                        openCatalogLinkModal(csvExportLink);
                      }
                    });
                  },
                },
                secondary: {
                  text: 'modal.button.close',
                  onClick: (modalAPI) => modalAPI.close(),
                },
                x: {
                  onClick: () =>
                    biLogger.integrationModalCloseViaCloseBar(biData),
                },
              },
              onOpened: () => biLogger.integrationModalView(biData),
              onClosed: () => biLogger.integrationModalClosed(biData),
            });
          };

          const updateLinkAndOpenCorrectModal = ({ link }) =>
            link
              ? (csvExportLink = link) && openCatalogLinkModal(csvExportLink)
              : openRequirementsModal();

          !csvExportLink
            ? api
                .getIntegrationInstance()
                .then((instance) => {
                  fetchCsvExportLink = () =>
                    experiments['specs.promote.mi.NewCatalogService'] === 'true'
                      ? get({
                          instance,
                          apiBaseUrl: `https://www.wix.com/_api/promote-catalogs/url?type=products&platform=facebook&mode=1`,
                        })({ path: '' }).then((link) => ({ link }))
                      : get({
                          instance,
                          apiBaseUrl: `${config.apiBaseUrl}facebook-catalog/`,
                        })({ path: 'link' });
                  return fetchCsvExportLink();
                })
                .then(updateLinkAndOpenCorrectModal)
            : openCatalogLinkModal(csvExportLink);
        },
      };
      const defaultArticleLink =
        'https://wix.wixanswers.com/apps/widget/v1/wix/3b11861f-3ac4-4c19-8d31-72e395808dac/view/en/article/3f594a32-3e34-4a2d-9b92-f730d4caa361';
      resolve({
        title: 'facebook-catalog.details-page.title',
        description: 'facebook-catalog.details-page.subtitle',
        documentationUrl: defaultArticleLink,
        articleId: 'facebook-catalog.details-page.articleId',
        actions: [getDataFeedAction],
      });
    }),
});

export default integration;
